import { _x } from '@wordpress/i18n'
import { useRef, useState, useEffect, useCallback } from 'react'
import { useInfiniteHits, useSearchBox, useStats } from 'react-instantsearch'
import FilterPanel from './FilterPanel'
import HitList from './List'
import useScrollDirection from '../../../../assets/frontend/js/hooks/useScrollDirection'
import useBreakpoint from '../../../../assets/frontend/js/hooks/breakpoint'
import Sticky from '../../../../assets/frontend/js/components/Sticky'
import useIsFullscreen from '../../../../assets/frontend/js/hooks/useIsFullscreen'
import ActionButtons from '../../../../assets/frontend/js/components/ActionButtons'
import LayoutToggle from '../../../../assets/frontend/js/components/LayoutToggle'

export default function SearchUI() {
  const { items, isLastPage, showMore } = useInfiniteHits()
  const { query } = useSearchBox()
  const { nbHits } = useStats()

  const timeoutRef = useRef<NodeJS.Timeout>()
  const lastTrackedQuery = useRef<string>('')

  const trackSearch = useCallback(() => {
    if (!window.dataLayer) return
    const cleanQuery = query.trim()
    if (cleanQuery && cleanQuery !== lastTrackedQuery.current) {
      lastTrackedQuery.current = cleanQuery
      window.dataLayer.push({
        event: 'sermons_search',
        search_query: cleanQuery,
        search_results_count: nbHits,
        search_no_results: nbHits === 0
      })
    }
  }, [query, nbHits])

  useEffect(() => {
    if (query.trim()) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }

      timeoutRef.current = setTimeout(trackSearch, 1000)
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [query, trackSearch])

  // const animatedItems = useViewTransition(items)

  const [layout, setLayout] = useState<'card' | 'list'>('card')

  const isDesktop = useBreakpoint('md')

  const wrapperRef = useRef<HTMLDivElement>(null)
  const isWrapperVisible = useIsFullscreen(wrapperRef)
  const scrollDirection = useScrollDirection()

  const collapseUi =
    !isDesktop && scrollDirection === 'down' && isWrapperVisible

  return (
    <>
      <div className="rounded overflow-clip" ref={wrapperRef}>
        <Sticky isSticky={!isDesktop}>
          <FilterPanel
            layout={layout}
            onLayoutChange={setLayout}
            collapsed={collapseUi}
            isDesktop={isDesktop}
          />
        </Sticky>
        <div className="my-2">
          <HitList items={items} layout={layout} />
          {!isLastPage && (
            <div className="text-center mt-2">
              <button
                type="button"
                className="btn btn-default"
                onClick={showMore}
              >
                {_x('Show more', 'Sermons List Show More Button', 'icf')}
              </button>
            </div>
          )}
        </div>
        <Sticky alignment="bottom">
          <ActionButtons
            collapsed={collapseUi}
            layoutToggle={
              <LayoutToggle
                variant="mobile"
                value={layout}
                onChange={setLayout}
              />
            }
          />
        </Sticky>
      </div>
    </>
  )
}
